import { IApplicationState } from 'setup/store'

export const selectNotifies = (state: IApplicationState) => state.notifies.data
